import React, { FC, useCallback, useEffect, useState } from "react";
import infoIcon from "../../../../assets/svg/purpleInfoIcon.svg";
import copyIcon from "../../../../assets/svg/copy_agency_link_icon.svg";

import { Input } from "antd";
import { openToast } from "../../../../Toasts";

import "./index.scss";
import { AdUploadFiles } from "../AdUploadFiles";
import {
  browseTemplatesUrls,
  canPerformAction,
  handleUploadNoticeFiles,
  noticeAdsSupportedFiles,
  StepKeysName,
  StepNames,
} from "../../../RaiseNoticeAdRequest/utils";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgencyQuotesFormDataAction,
  getFilesByStageAction,
  patchAgencyQuotesAction,
} from "../../../../store/actions/raiseAdRequest";
import { RaiseAdRequestState } from "../../../../store/types/raiseAdRequest";
import { NoticeAdComments } from "../NoticeAdComments";

const permittedRoles = ["admin", "only-approver","product-admin" ];
const MAX_NUMBER_OF_FILES = 5;
export const AdReleaseForm: FC = () => {
  const dispatch = useDispatch();
  const {
    quoteDetailsFormData,
    adReleaseFile,
    userRole,
    lastStepName,
    quoationApprovalFormData,
  } = useSelector(
    (state: { raiseAdRequest: RaiseAdRequestState }) => state.raiseAdRequest
  );

  const isStepAccessible = canPerformAction(
    userRole,
    permittedRoles,
    StepNames[3],
    lastStepName,
    quoationApprovalFormData.trashed_at
  );

    const [isCommentsDrawerOpen, setIsCommentsDrawerOpen] = useState(false);
  console.log("🚀 ~ AdReleaseForm ~ isStepAccessible:", isStepAccessible)

  const { selectedProductId, requestId } = useParams<{
    selectedProductId: string;
    requestId: string;
  }>();
  const [creativeFileList, setCreativeFileList] = useState<any[]>(adReleaseFile);
  const [quoteApprovalFileList, setQuoteApprovalFileList] = useState<any[]>(adReleaseFile);
  const [creativeApprovalFileList, setCreativeApprovalFileList] = useState<any[]>(adReleaseFile);


  useEffect(() => {
    dispatch(getAgencyQuotesFormDataAction(requestId));
    dispatch(
      getFilesByStageAction({ stage: "Ad Release", request_id: requestId })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isStepAccessible && !!userRole) {
      openToast("info", "You only have view access to this information.");
    }
  }, [isStepAccessible, userRole]);

  useEffect(() => {
   const creativeFiles = adReleaseFile.filter((file) =>
          file.original_filename?.startsWith("Creative")
        );

        const approvalQuotesFile = adReleaseFile.filter((file) =>
          file.original_filename?.startsWith("Quotes_Approval")
        );

        const approvalCreativeFile = adReleaseFile.filter((file) =>
          file.original_filename?.startsWith("Creative_Approval")
        );
    setCreativeFileList(creativeFiles);
    setQuoteApprovalFileList(approvalQuotesFile);
    setCreativeApprovalFileList(approvalCreativeFile);
  }, [adReleaseFile]);
  const handleCopy = useCallback(() => {
    const inputField = `${window.location.origin}#/?folder=${quoteDetailsFormData?.folder_url}`;
    if (inputField) {
      navigator.clipboard
        .writeText(inputField)
        .then(() => {
          openToast("success", "Text copied to clipboard.");
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
        });
    }
  },[quoteDetailsFormData]);

  const handleCreativeTemplates = useCallback(() => {
    window.open(browseTemplatesUrls[selectedProductId], "_blank");
  }, [selectedProductId]);

    const handleCreativeUploadClick = useCallback(() => {
    window.open(`${window.location.origin}#/?folder=${quoteDetailsFormData?.folder_url}`, "_blank");
  }, [quoteDetailsFormData]);

  const handleSubmitUploadFile = useCallback(() => {
    if (!creativeFileList.length) {
      openToast("error", "Please upload a file in Creative Dropbox.");
      return;
    }

        if (!quoteApprovalFileList.length) {
      openToast("error", "Please upload a file in Approval Mail of Quotes Dropbox.");
      return;
    }

        if (!creativeApprovalFileList.length) {
      openToast("error", "Please upload a file in Approval Mail of Creative Dropbox.");
      return;
    }
    const requiredFilesToUpload = [...creativeFileList, ...quoteApprovalFileList, ...creativeApprovalFileList].filter((file) => !!file.name);
    if(!!requiredFilesToUpload.length){

      handleUploadNoticeFiles(
        requiredFilesToUpload,
        dispatch,
        requestId,
        "Final Market go Live",
        "Ad Release",
        StepKeysName.FinalMarketGoLive,
        selectedProductId
      );
    }else{
      dispatch(
                patchAgencyQuotesAction({
                  status: "Accepted",
                  stage: "Final Market go Live",
                  nextStepKey: StepKeysName.FinalMarketGoLive,
                  workspaceId: selectedProductId,
                  id: requestId,
                })
              );
    }
  }, [dispatch, creativeFileList, quoteApprovalFileList, creativeApprovalFileList, requestId, selectedProductId]);
  return (
    <>
      <div className="layout-wrapper">
        {/* Scrollable Form */}
        <div className="layout-wrapper__body">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "2rem",
              border: "2px solid #F3ECFF",
              borderRadius: "1rem",
            }}
          >
            <div
              style={{
                padding: "2rem 1rem",
                background: "#F3ECFF",
                width: "100%",
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <img src={infoIcon} alt="Info Icon" style={{ color: "red" }} />
                <div
                  style={{ color: "#000", fontSize: "1.4rem", fontWeight: 600 }}
                >
                  No creatives yet?
                </div>
              </div>

              <div
                style={{
                  color: "#000205",
                  fontSize: "1.4rem",
                  fontWeight: 200,
                  paddingLeft: "3rem",
                }}
              >
                Download and edit creative templates before uploading your final
                assets.
              </div>

              <div style={{ marginTop: "0.5rem", paddingLeft: "3rem" }}>
                <button
                  className="btn btn--outline-purple"
                  style={{ background: "transparent", padding: "0.5rem 1rem" }}
                  onClick={handleCreativeTemplates}
                >
                  See Creative Templates
                </button>
              </div>
            </div>
          </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                marginTop: "2rem",
              }}
            >

              <div
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 500,
                  color: "#6810B6",
                  cursor: "pointer",
                  marginTop: "1rem",
                }}
                onClick={() => setIsCommentsDrawerOpen(true)}
              >
                + Add Comments
              </div>
            </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Drop your Creatives in the folder below
              <span style={{ color: "red" }}>*</span>
            </div>

           

            <div
              style={{ fontSize: "1.4rem", fontWeight: 500, color: "#556179" }}
            >
              Upload the necessary files for processing:{" "}
              <span style={{ color: "#6B38C4" }}>
                Creative Files* (.eml, .msg, .pdf file only)
              </span>
            </div>
            <AdUploadFiles
              accept={noticeAdsSupportedFiles.emails.join(",")}
              fileList={creativeFileList}
              setFileList={setCreativeFileList}
              currentStage={"Ad Release"}
              isUesrPermitted={isStepAccessible}
              isMultiple={true}
              maxFiles={MAX_NUMBER_OF_FILES}
              fileSize={50 * 1024 * 1024}
              fileSizeString={"50MB"}
              prefix="Creative"
            />
          </div>



                    <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Drop your Approval Mail of Quotes in the folder below
              <span style={{ color: "red" }}>*</span>
            </div>

           

            <div
              style={{ fontSize: "1.4rem", fontWeight: 500, color: "#556179" }}
            >
              Upload the necessary files for processing:{" "}
              <span style={{ color: "#6B38C4" }}>
                Approval Emails of Quotes* (.eml, .msg, .pdf file only)
              </span>
            </div>
            <AdUploadFiles
              accept={noticeAdsSupportedFiles.emails.join(",")}
              fileList={quoteApprovalFileList}
              setFileList={setQuoteApprovalFileList}
              currentStage={"Ad Release"}
              isUesrPermitted={isStepAccessible}
              isMultiple={true}
              maxFiles={2}
              fileSize={50 * 1024 * 1024}
              fileSizeString={"50MB"}
              prefix="Quotes_Approval"
            />
          </div>

                              <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                color: "#000",
                fontSize: "1.8rem",
                fontWeight: 500,
              }}
            >
              Drop your Approval Mail of Creative in the folder below
              <span style={{ color: "red" }}>*</span>
            </div>
            <div
              style={{ fontSize: "1.4rem", fontWeight: 500, color: "#556179" }}
            >
              Upload the necessary files for processing:{" "}
              <span style={{ color: "#6B38C4" }}>
                Approval Emails of Creatives* (.eml, .msg, .pdf file only)
              </span>
            </div>
            <AdUploadFiles
              accept={noticeAdsSupportedFiles.emails.join(",")}
              fileList={creativeApprovalFileList}
              setFileList={setCreativeApprovalFileList}
              currentStage={"Ad Release"}
              isUesrPermitted={isStepAccessible}
              isMultiple={true}
              maxFiles={2}
              fileSize={50 * 1024 * 1024}
              fileSizeString={"50MB"}
              prefix="Creative_Approval"
            />
          </div>
        </div>
        {!!isStepAccessible ? (
          <div className="layout-wrapper__footer">
            <button
              className="btn btn--purple"
              onClick={handleSubmitUploadFile}
              disabled={!creativeFileList.length}
            >
              Submit for approval
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>

            <NoticeAdComments
              setIsCommentsDrawerOpen={setIsCommentsDrawerOpen}
              isCommentsDrawerOpen={isCommentsDrawerOpen}
            />
    </>
  );
};
